<template>
    <public-layout>
        <div class="w-full h-screen flex flex-col epic-cover-public">
            <nav id="header" class="bg-default-blue-green w-full z-10 shadow-md sm:px-6 px-0">
                <div class="w-full mx-auto flex flex-wrap items-center mt-0 pt-3 pb-3">
                    <header-logo :is_epic_vault_enabled="true" :is_public="true" />

                    <div class="w-1/2 pr-0">
                        <div class="float-right"></div>
                    </div>
                </div>

                <div class="container mx-auto hidden lg:block">
                    <div class="flex items-center"></div>
                </div>
            </nav>
            <div
                class="flex flex-col justify-center items-center mt-8 md:my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-32"
                data-cy="cover-vault-public-body"
            >
                <div class="text-center pb-4" data-cy="cover-header">
                    {{ association.public_cover_search_tagline }}
                </div>
                <div class="flex flex-row pb-4 w-full max-w-2xl items-center justify-center">
                    <form-cover-search
                        :association="association"
                        :processing="processing"
                        :search_form="search_form"
                        @formSubmit="onSearch"
                        @reset="onReset"
                    />
                </div>
                <div v-if="cover.status == null" data-cy="cover-body" class="h-96 max-w-xl" />
                <div
                    v-if="cover.status == false"
                    data-cy="cover-body"
                    class="h-96 max-w-xl w-full shadow-md rounded-md flex flex-col justify-center"
                >
                    <div class="w-52 self-center pb-6">
                        <img class="w-full h-full" :src="'/images/cover-failed.png'" alt="logo" />
                    </div>
                    <div
                        class="text-center font-bold text-2xl lg:text-4xl text-default-red pb-6"
                        data-cy="cover-status"
                    >
                        {{ $t('covers.public.no_cover_status') }}
                    </div>
                    <div class="text-center" data-cy="cover-not-found">
                        {{ $t('covers.public.no_cover_message') }}
                    </div>
                </div>
                <div
                    v-if="cover.status == true"
                    data-cy="cover-body"
                    class="h-96 max-w-xl w-full shadow-md rounded-md flex flex-col justify-center"
                >
                    <div class="w-52 self-center pb-6">
                        <img class="w-full h-full" :src="'/images/cover-success.png'" alt="logo" />
                    </div>
                    <div
                        class="text-center font-bold text-2xl lg:text-4xl text-default-teal pb-6"
                        data-cy="cover-status"
                    >
                        {{ $t('covers.public.cover_status') }}
                    </div>
                    <div class="text-center" data-cy="cover-insurer">
                        <span class="font-bold">{{ $t('covers.public.cover_insurer') }}</span>
                        <span>{{ cover.data.insurer }}</span>
                    </div>
                    <div class="text-center" data-cy="cover-period">
                        <span class="font-bold">{{ $t('covers.public.cover_period') }}</span>
                        <span>{{ cover.data.cover_period }}</span>
                    </div>
                    <div class="text-center" data-cy="cover-vehicle">
                        <span class="font-bold">{{ $t('covers.public.cover_vehicle') }}</span>
                        <span>{{ cover.data.vehicle_info }}</span>
                    </div>
                </div>
            </div>
        </div>
    </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout.vue';
import HeaderLogo from '@/components/layout_sections/HeaderLogo.vue';
import FormCoverSearch from '@/components/forms/covers/public/Search.vue';

export default {
    components: {
        HeaderLogo,
        PublicLayout,
        FormCoverSearch,
    },
    data() {
        return {
            search_form: {
                basic_search: '',
            },
            basic_search: '',
            cover: {
                status: null,
                data: {},
            },
            association: {
                public_cover_search_tagline: '',
                public_cover_search_min_search_value: 2,
            },
            processing: false,
        };
    },
    mounted() {
        this.$http
            .get('/api/covers/public/check/' + this.$route.params.code)
            .then((response) => {
                this.association = {
                    ...response.data.data,
                    public_cover_search_tagline:
                        response.data.data.public_cover_search_tagline != '' ||
                        response.data.data.public_cover_search_tagline != null
                            ? response.data.data.public_cover_search_tagline
                            : this.$t('covers.public.header'),
                    company: {},
                };

                this.$store.dispatch('user/updateCurrentAssociation', this.association);
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status == 404) {
                    this.$router.push({
                        name: 'login',
                    });
                } else {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'COVP01' }),
                    });
                }
            });
    },
    methods: {
        onSearch() {
            if (this.search_form.basic_search !== '') {
                this.processing = true;

                this.$http
                    .post('/api/covers/public/' + this.$store.state.user.current_association.id, {
                        basic_search: this.search_form.basic_search,
                    })
                    .then((response) => {
                        this.processing = false;

                        if (response.data.status == 'success') {
                            this.cover = {
                                status: true,
                                data: response.data.data,
                            };
                        } else {
                            this.cover = {
                                status: false,
                                data: {},
                            };
                        }
                    })
                    .catch((error) => {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'COVP02' }),
                        });
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        },
        onReset() {
            this.cover = {
                status: null,
                data: {},
            };
        },
    },
};
</script>
